<template>
    <div class="mrc-mortgagerates">
        <component v-if="options?.showEquityMrc" is="script" src="https://www.mortgageresearchcenter.com/scripts/movoto.js"
        data-mrc="Movoto" data-mrc-supported-loan-types="equity" async></component>
        <component v-else-if="options?.showNormalMrc" is="script" src="https://www.mortgageresearchcenter.com/scripts/movoto.js"
        data-mrc="Movoto" async data-mrc-success-callback="submissionReturn"></component>
        <template v-else>
            <component is="script" src="https://www.mortgageresearchcenter.com/scripts/movotoConfirmInfo.js"
                data-mrc="Movoto" async data-mrc-success-callback="submissionReturn"></component>
        </template>
    </div>
</template>

<script src="./mrc-mortgagerates.js"></script>
<style lang="scss">
    @use "./mrc-mortgagerates.scss" as *;
</style>
